import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { BASE_RESOURCE } from '../../config';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'fr',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export const initI18n = (): Promise<any> =>
  new Promise((res) => {
    const namespaces: Array<string> = [
      'app',
      'error',
      'comparisonPage',
      'creditCheckRejection',
      'creditCheckPending',
      'creditCheck',
      'landingPage',
      'outletPage',
      'carOptions',
      'consents',
      'step1',
      'step2',
      'step3',
      'step4',
      'step5',
      'validation',
      'accessoriesOptions',
      'identLandingPage',
      'identFailedPage',
      'identSuccessPage',
      'eSignLandingPage',
      'eSignSuccessPage',
      'eSignRefusedPage',
      'authenticate',
      'deliveryCostModal',
      'registrationCostModal',
      'sf-sac',
      'searchBar',
      'shoppingCart',
      'prospectSearchPopupModal',
      'dashboard',
      'dashboardSubpageDocuments',
      'dashboardSubpageDocumentsRow',
      'noVehiclesErrorModal',
      'dashboardNotesUtils',
      'conversationHeader',
      'conversationListItem',
      'conversation',
      'filters',
      'newConversationCard',
      'notesPage',
      'warningModal',
      'outletSearchCombobox',
    ];
    Promise.all(
      namespaces.map(
        (item) =>
          import(`../../resources/${BASE_RESOURCE}/content/${item}.json`).then((module) => {
            i18n.addResourceBundle('fr', item, module.default, true, true);
          })

        // TODO uncomment below code when multibrand will be implemented
        // .then(() => {
        //   /**
        //    * Request brand-specific resources and override (using deep) the
        //    * resources for specific brand. Make sure to chain those to avoid
        //    * race conditions.
        //    */
        //   import(`../../resources/${brandType}/content/${item}.json`)
        //     .then(module => {
        //       i18n.addResourceBundle('de', item, module.default, true, true);
        //     })
        //     .catch(() => {});
        // })
      )
    ).then(res);
  });
